import React from 'react'
import { connect } from 'react-redux'
import { CloseOutlined } from '@ant-design/icons'
import SearchInput from './SearchInput'

const HEADER_BG_LIGHT = '#ffffff'
const HEADER_BG_DARK = '#283142'

export const NavSearch = (props) => {
  const { active, close, headerNavColor, currentTheme, mode, resolvedHeaderNavColor } =
    props

  const headerBgBase =
    currentTheme === 'dark' ? HEADER_BG_DARK : HEADER_BG_LIGHT

  return (
    <div
      className={`nav-search ${active ? 'nav-search-active' : ''} ${mode}`}
      style={{
        backgroundColor:
          resolvedHeaderNavColor || headerNavColor || headerBgBase,
      }}
    >
      <SearchInput close={close} active={active} mode={mode} isMobile />
      <div className="nav-close" onClick={close}>
        <CloseOutlined />
      </div>
    </div>
  )
}

const mapStateToProps = ({ theme }) => {
  const { headerNavColor, currentTheme } = theme
  return { headerNavColor, currentTheme }
}

export default connect(mapStateToProps, {})(NavSearch)
